import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  inactiveUserPageTitle: 'We need more information',
  inactiveUserMessage1: 'Dear',
  inactiveUserMessage2:
    ', your EFEX account is currently on hold either due to lack of sending requested documentation or due to inactivity. ',
  inactiveUserMessage3:
    'You are a very important user for us, so in order to continue sending payments please contact us at our email',
  inactiveUserMessage4:
    'or click on the following button and send a message directly to the customer service department.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const INACTIVE_USER_LABELS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    inactiveUserPageTitle: 'Necesitamos más información',
    inactiveUserMessage1: 'Estimado',
    inactiveUserMessage2:
      ', tu cuenta EFEX se encuentra inactiva actualmente ya sea por falta de documentación requerida o por inactividad.',
    inactiveUserMessage3:
      'Para nosotros eres un usuario muy importante así que por favor para poder seguir operando contáctanos a través de nuestro correo',
    inactiveUserMessage4:
      'o dale click al siguiente botón y envíale un mensaje directamente al departamento de atención al cliente.',
  },
};

export default INACTIVE_USER_LABELS;
